import { createReducer } from '@reduxjs/toolkit';
import { buildActionStatus, actionManager } from '../utils';
import * as ma from './moodleActions';

const initialState = {
  meetingHasNotStarted: false,
  actionStatus: buildActionStatus(ma),
};

const moodleReducer = createReducer(initialState, {
  [ma.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [ma.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [ma.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [ma.setMeetingHasNotStartedAction]: (state, { payload }) => {
    return {
      ...state,
      meetingHasNotStarted: payload,
    };
  },
});

export default moodleReducer;
